import { BuiltinUiState, Feature, IActionPointInfo, InjectorService, StateManager } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';
import { showImagesJoint } from '@src/js/common/ark-extensions/dc-components/toolkit-dialog';
import { FIXED_KEYS_DOUBLE } from '../../schema/constant';
import ArkLoader from '@src/js/common/ark-extensions';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { EventPosition, TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

const aidApprecMenuMap = {
    quickTool: 'pptquicktool',
};


@Feature()
export class ImagesJointFeature extends BaseToolbarFeature {
    public id = config.id;
    public constructor() {
        super();
    }

    public showImagesJoint(info: IActionPointInfo) {
        const aidPosition = 'toolbar';
        const fromPage = EventPosition.PC_TOOLBAR;
        const apprec1 = this.getContentAidOptions(info);

        showImagesJoint({
            aidPosition,
            fromPage,
            contentAidOptions: {
                apprec1,
            },
        });
        this.tdwReportImagesJointClick(apprec1);
    }

    private getContentAidOptions(info: IActionPointInfo) {
        const state = InjectorService.get(StateManager);
        const tab = state.get(BuiltinUiState.RibbonActiveTab).value as string;
        if (info.path[0] === 'pic-handle-toolbar') {
            return tab === FIXED_KEYS_DOUBLE.TOOLBAR_PICTURE ? 'picture' : 'beautify';
        }
        return aidApprecMenuMap[info.path[0]] || '';
    }

    private tdwReportImagesJointClick(apprec1) {
        const vipInfo = ArkLoader.extensionService.dependentServiceCombinder?.accountApplication?.vipInfo;
        tdw({
            opername: TDWOperationType.DOC_VIP_SLIDEQUICKTOOL,
            module: TDWModuleType.FUNCTION,
            action: TDWActionType.CLICK,
            ver5: vipInfo.type,
            ver6: 'picturejoint',
            ver8: apprec1,
            ver9: EventPosition.PC_TOOLBAR,
            ver12: 'slide',
        });
    }
}
